import { jsx as _jsx } from "react/jsx-runtime";
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { useTheme } from 'styled-components';
import { AssistantSiderLinkContainer } from './styles';
const AssistantSiderLink = ({ label, href, onClick, Icon, }) => {
    const theme = useTheme();
    return (_jsx(AssistantSiderLinkContainer, { to: href, defaultStyle: theme.colors.grey_1, transparent: true, headingIcon: Icon && _jsx(Icon, { size: 18, color: theme.colors.grey_2 }), onClick: onClick, children: _jsx(Typography, { elementTheme: "body3", children: label }) }));
};
export default AssistantSiderLink;
